import { StandardEvents } from '@shopify/events';

(function () {
  var header = document.getElementById('header-component');
  var moneyFormat = header ? header.dataset.moneyFormat : '${{amount}}';
  var currentCount = 0;

  /* ── Money formatting ──
     Cart AJAX API values are always expressed ×100 ("cents"), regardless of
     the currency's real decimal precision (e.g. JPY), so this always divides
     by 100 — unlike @theme/money-formatting, which is currency-precision-aware
     and intended for already-decimal-normalized values (see facets.js). */
  function formatWithDelimiters(cents, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands == null ? ',' : thousands;
    decimal = decimal == null ? '.' : decimal;
    var value = (cents / 100).toFixed(precision);
    var parts = value.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var fraction = parts[1] ? decimal + parts[1] : '';
    return whole + fraction;
  }

  function formatMoney(cents) {
    var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount';
    var value;
    switch (placeholder) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
        break;
    }
    var formatted = moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, value);
    return formatted.replace(/([.,])00(?!\d)/, '');
  }

  /* ── Bag count ── */
  function setCount(n) {
    currentCount = n;
    var mobileBagCount = document.getElementById('header-mobile-bag-count');
    if (mobileBagCount) {
      mobileBagCount.textContent = n > 0 ? ' (' + n + ')' : '';
    }
    var link = document.querySelector('header-menu a[href="/cart"]');
    if (!link) return;
    var titleEl = link.querySelector('.menu-list__link-title');
    if (!titleEl) return;
    var span = document.getElementById('header-bag-count');
    if (!span) {
      span = document.createElement('span');
      span.id = 'header-bag-count';
    }
    span.textContent = n > 0 ? ' (' + n + ')' : '';
    if (!titleEl.contains(span)) {
      titleEl.appendChild(span);
    }
  }

  /* ── Bag panel rendering ── */
  function renderBagPanel(cart) {
    var panel = document.getElementById('bag-panel');
    if (!panel) return;
    var itemsEl = panel.querySelector('.bag-panel__items');
    var totalEl = panel.querySelector('.bag-panel__total');
    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '<p class="bag-panel__empty">Your bag is empty</p>';
      totalEl.textContent = '';
      return;
    }
    itemsEl.innerHTML = cart.items.map(function (item) {
      var imgUrl = item.featured_image && item.featured_image.url
        ? item.featured_image.url.replace(/(\.\w{3,4})(\?|$)/, '_80x80$1$2')
        : '';
      return '<div class="bag-panel__item" data-key="' + item.key + '">' +
        '<div class="bag-panel__item-img-wrap">' +
          (imgUrl ? '<img class="bag-panel__item-img" src="' + imgUrl + '" alt="" />' : '') +
        '</div>' +
        '<div class="bag-panel__item-info">' +
          '<a href="' + item.url + '" class="bag-panel__item-title">' + item.product_title + '</a>' +
          '<div class="bag-panel__item-price">' + formatMoney(item.final_price) + '</div>' +
          '<div class="bag-panel__item-qty">Qty: ' + item.quantity + '</div>' +
          '<div class="bag-panel__item-actions">' +
            '<button class="bag-panel__action-btn bag-panel__remove" data-key="' + item.key + '" type="button">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
    totalEl.textContent = 'Total:  ' + formatMoney(cart.total_price);
    itemsEl.querySelectorAll('.bag-panel__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
        }).then(function (r) { return r.json(); }).then(function (updated) {
          renderBagPanel(updated);
          setCount(updated.item_count);
          document.dispatchEvent(new CustomEvent('cart:update', { detail: { resource: updated } }));
        });
      });
    });
  }

  function fetchAndRenderBagPanel() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderBagPanel);
  }

  /* ── Scroll lock: prevent body scroll while a nav or bag panel is open ── */
  function updateScrollLock() {
    var anyOpen = document.body.classList.contains('bag-panel--open') ||
      document.querySelector('.menu-list__list-item.nav-panel--locked');
    document.documentElement.toggleAttribute('scroll-lock', !!anyOpen);
  }

  /* ── Bag panel open / close ── */
  function openBagPanel() {
    /* Close any locked nav panels */
    document.querySelectorAll('.menu-list__list-item.nav-panel--locked').forEach(function (li) {
      li.classList.remove('nav-panel--locked');
      var l = li.querySelector('.menu-list__link[aria-haspopup="true"]');
      if (l) l.setAttribute('aria-expanded', 'false');
    });
    document.body.classList.add('bag-panel--open');
    fetchAndRenderBagPanel();
    updateScrollLock();
  }

  function closeBagPanel() {
    document.body.classList.remove('bag-panel--open');
    updateScrollLock();
  }

  /* ── Cart update events ── */
  document.addEventListener('cart:update', function (e) {
    var count = e.detail && e.detail.resource && e.detail.resource.item_count;
    if (count !== undefined) setCount(count);
  });

  /* The theme's own add-to-cart flow (product-form.js, quick-add.js, etc.)
     only ever dispatches the standard Shopify cart event, never the
     'cart:update' custom event above (that one's only fired by this file's
     own bag-panel remove button) -- so adding a product never updated this
     header's BAG count, only removing one via the desktop bag panel did.
     Listen for the standard event too, same pattern every other cart-aware
     component in this theme already uses (see header-actions.js/cart-icon.js). */
  document.addEventListener(StandardEvents.cartLinesUpdate, function (e) {
    if (!e.promise) return;
    e.promise.then(function (result) {
      var cart = result && result.cart;
      if (cart && typeof cart.totalQuantity === 'number') setCount(cart.totalQuantity);
    }).catch(function (error) {
      if (error && error.name !== 'AbortError') console.warn('[header-panels] Cart update promise rejected:', error);
    });
  });

  /* ── Click on BAG: on desktop open bag panel; on mobile fall back to cart drawer ── */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('header-menu a[href="/cart"]');
    if (!link) return;
    var panel = document.getElementById('bag-panel');
    if (panel && window.innerWidth >= 750) {
      e.preventDefault();
      if (document.body.classList.contains('bag-panel--open')) {
        closeBagPanel();
      } else {
        openBagPanel();
      }
      return;
    }
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer || !drawer.offsetParent) return;
    e.preventDefault();
    drawer.open();
  });

  /* ── Nav panel: lock open + close button + image hover ── */
  function closeAllNavPanels() {
    document.querySelectorAll('.menu-list__list-item.nav-panel--locked').forEach(function (li) {
      li.classList.remove('nav-panel--locked');
      var l = li.querySelector('.menu-list__link[aria-haspopup="true"]');
      if (l) l.setAttribute('aria-expanded', 'false');
    });
    updateScrollLock();
  }

  function initNavPanel() {
    var navCloseTimer = null;
    var menuLinks = document.querySelectorAll('header-menu .menu-list__link[aria-haspopup="true"]');

    menuLinks.forEach(function (link) {
      new MutationObserver(function () {
        if (link.getAttribute('aria-expanded') === 'true') {
          clearTimeout(navCloseTimer);
          closeBagPanel();
          document.querySelectorAll('.menu-list__list-item.nav-panel--locked').forEach(function (el) {
            el.classList.remove('nav-panel--locked');
          });
          link.closest('.menu-list__list-item').classList.add('nav-panel--locked');
          updateScrollLock();
        }
      }).observe(link, { attributes: true, attributeFilter: ['aria-expanded'] });

      /* Hovering back onto a nav link cancels any pending close */
      link.addEventListener('pointerenter', function () { clearTimeout(navCloseTimer); });
    });

    document.querySelectorAll('.nav-panel__close-btn').forEach(function (btn) {
      btn.addEventListener('click', closeAllNavPanels);
    });

    document.querySelectorAll('.menu-list__submenu').forEach(function (submenu) {
      var li = submenu.closest('.menu-list__list-item');
      var panelLink = li ? li.querySelector('.menu-list__link[aria-haspopup="true"]') : null;

      /* Close when pointer leaves the submenu panel — 100ms grace period handles
         the brief gap when moving between the submenu and its nav link */
      submenu.addEventListener('pointerleave', function () {
        navCloseTimer = setTimeout(function () {
          if (li) li.classList.remove('nav-panel--locked');
          if (panelLink) panelLink.setAttribute('aria-expanded', 'false');
          updateScrollLock();
        }, 100);
      });
      submenu.addEventListener('pointerenter', function () { clearTimeout(navCloseTimer); });

      /* Image hover inside the panel */
      var images = submenu.querySelectorAll('.nav-panel__img');
      submenu.querySelectorAll('.nav-panel__link').forEach(function (link) {
        link.addEventListener('mouseenter', function () {
          var href = link.getAttribute('href');
          images.forEach(function (img) {
            img.style.opacity = img.dataset.href === href ? '1' : '0';
          });
        });
      });
      submenu.addEventListener('mouseleave', function () {
        images.forEach(function (img) { img.style.opacity = '0'; });
      });
    });
  }

  /* ── Bag panel: click-only open, close button + hover-outside ── */
  function initBagPanel() {
    var panel = document.getElementById('bag-panel');
    if (!panel) return;
    var bagLink = document.querySelector('header-menu a[href="/cart"]');
    if (!bagLink) return;
    var bagLi = bagLink.closest('.menu-list__list-item');
    if (!bagLi) return;

    panel.querySelector('.bag-panel__close-btn').addEventListener('click', closeBagPanel);

    /* Close when pointer leaves the bag panel (anywhere — even back onto header) */
    panel.addEventListener('pointerleave', closeBagPanel);
  }

  /* ── Init ── */
  function init() {
    setCount(header ? parseInt(header.dataset.cartItemCount, 10) || 0 : 0);
    initNavPanel();
    initBagPanel();
    var link = document.querySelector('header-menu a[href="/cart"]');
    if (!link) return;
    new MutationObserver(function () {
      if (!document.getElementById('header-bag-count')) {
        setCount(currentCount);
      }
    }).observe(link, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
